import React from 'react';
import { withThemeNext } from '../../layout/theme-next';
import FBSerialsTable from '../FBSerialsTable';
import { useLHRSSerialNumbers } from './hooks';
import FBMPIProcedureItemSerialsTablePlaceholder from './placeholder';
import { FBMPIProcedureItemSerialsTableProps } from './types';

const FBMPIProcedureItemSerialsTableLoaded: React.FC<FBMPIProcedureItemSerialsTableProps> = ({
  name = '',
  sequenceIndex = 0,
  isDisabled = false,
  toolbarRef,
}) => {
  const {
    shouldShowSerials,
    stepSerialNumbers,
    isLoading,
    updateSerialNumber,
    updateSerialNumbers,
  } = useLHRSSerialNumbers({
    name,
    sequenceIndex,
    shouldDisableInSubsequentSteps: true,
  });

  if (!shouldShowSerials) {
    return null;
  }

  return (
    <div data-cy="items-built">
      <FBSerialsTable
        isLoading={isLoading}
        isDisabled={isDisabled}
        serialNumbers={stepSerialNumbers}
        onUpdate={updateSerialNumber}
        onBulkUpdate={updateSerialNumbers}
        toolbarRef={toolbarRef}
        shouldShowStepAndSequence
      />
    </div>
  );
};

const FBMPIProcedureItemSerialsTable: React.FC<FBMPIProcedureItemSerialsTableProps> = (props) => {
  if (props.isDocumentMPI) {
    return <FBMPIProcedureItemSerialsTablePlaceholder />;
  }

  return <FBMPIProcedureItemSerialsTableLoaded {...props} />;
};

export default withThemeNext(FBMPIProcedureItemSerialsTable);
